module.exports = __webpack_public_path__ + "static/media/24-hours.8bc474a1.svg";